const OWN_ERROR_FRAGMENTS = [
  // the account page shows the refusal at the field or in its password prompt
  '/internal/account',
  // the merchant card block shows the refusal under the list
  '/api-ip-allowlist',
  // the staff list: the protected accounts list is optional, the reset reports in its own dialog
  '/employee/second-factor/enabled',
  '/second-factor/reset',
]

/**
 * Requests of the sign-in, the account page, the merchant allowlist and the staff second factor
 * actions: each shows its own text, so the common error dialogs stay out of the way.
 */
export const showsItsOwnErrors = (url: string | undefined, loginUrl: string): boolean => {
  if (!url) {
    return false
  }

  // the sign-in and its second step live under one prefix
  return url.startsWith(loginUrl) || OWN_ERROR_FRAGMENTS.some((fragment) => url.includes(fragment))
}
